export enum InsuranceDuration {
    OneMonth = '1',
    TwoMonths = '2',
    ThreeMonths = '3',
    FourMonths = '4',
    SixMonths = '6',
    TwelveMonths = '12',
}
